import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface CnisConfigFormValues {
  release: string;
  ontap: string | undefined;
  tickets: string;
}

export const defaultValues: CnisConfigFormValues = {
  release: '',
  ontap: '',
  tickets: ''
};

const schema = yup.object({
  release: yup.string().required('Release Name is required').min(1, 'Release Name cannot be empty'),
  ontap: yup.string().optional(),
  tickets: yup.string().required('Release Ticket Numbers are required').min(1, 'Release Ticket Numbers cannot be empty')
});

export function useCnisConfigForm(initialValues?: Partial<CnisConfigFormValues>) {
  return useForm<CnisConfigFormValues>({
    mode: 'onSubmit',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: yupResolver(schema) as any,
    defaultValues: { ...defaultValues, ...initialValues }
  });
}
